import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-allegati-show-password',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog [(visible)]="visible" (onHide)="hide.emit()">
    <p-header>Password allegato</p-header>
    <div>{{password()}}</div>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Chiudi" (click)="hide.emit()"
        class="p-button-secondary"></button>
      <button pButton type="button" icon="pi pi-copy" label="Copia" [cdkCopyToClipboard]="password() ?? ''"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
  `]
})

export class AllegatiShowPasswordComponent {
  visible = model.required<boolean>();
  password = input.required<string | null | undefined>();
  hide = output();
}
